import { render, staticRenderFns } from "./ReminderSettings.vue?vue&type=template&id=4ed6d626"
import script from "./ReminderSettings.vue?vue&type=script&lang=ts"
export * from "./ReminderSettings.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4ed6d626')) {
      api.createRecord('4ed6d626', component.options)
    } else {
      api.reload('4ed6d626', component.options)
    }
    module.hot.accept("./ReminderSettings.vue?vue&type=template&id=4ed6d626", function () {
      api.rerender('4ed6d626', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/settings-default/ReminderSettings.vue"
export default component.exports